export const propertyTypePathEn = {
    'all-residential': true,
    residential: true,
    house: true,
    apartment: true,
    'shop-house': true,
    shophouse: true,
    land: true,
    factory: true,
    office: true,
    warehouse: true,
    'commercial-space': true,
};

export const propertyTypePathId = {
    residensial: true,
    rumah: true,
    apartemen: true,
    ruko: true,
    tanah: true,
    pabrik: true,
    kantor: true,
    gudang: true,
    'ruang-usaha': true,
};

export const DEFAULT_NPL_FLAG = 'ASET BANK';

export const DEFAULT_NPL_FLAGS = ['ASET BANK'];

export const FILTER_PROMO_FLAGS = ['njop', 'priceDrop', 'bankAsset'];

export const DEFAULT_UNDER_1_YEAR_FLAGS = ['Baru direnovasi', 'Baru dibangun'];
